import qix_global from '~/api/session.js'
import { logger } from '~/utils/logger'

export const state = () => ({
  bannerMessage: '',
  //Network information, Principal names, and Assistant Superintendent names displayed on School Profiles reflect end of year 2023-24 values.', //  `Note: School Profiles will be unavailable on Saturday, May 22nd, 2021, due to scheduled maintenance.`
  bannerMessageLn2:
    'School Profiles will be updated in early-September to reflect the new 2024-25 values.',
  comparisonYearText: 'from previous year'
})
//Network information, Principal names, and Assistant Superintendent names displayed on School Profiles reflect end of year 2023-24 values.\nSchool Profiles will be updated in mid-August to reflect the new 2024-25 values.'
export const actions = {
  async nuxtServerInit({ dispatch }, { app }) {
    const { engine, session } = await qix_global({ app: app })

    try {
      await dispatch('schools/get_maxSchoolYear', { engine: engine })

      await dispatch('schools/get_maxSchoolYear_StudentMetrics', {
        engine: engine
      })
      await dispatch('schools/get_maxSchoolYear_SPR', { engine: engine })
      await dispatch('schools/get_maxSchoolYear_AEPR', { engine: engine })
      await dispatch('schools/get_maxSchoolYear_DWS', { engine: engine })
      await dispatch('schools/get_maxSchoolYear_Oct1', { engine: engine })
      await dispatch('schools/get_maxSchoolYear_Climate', { engine: engine })
      await dispatch('schools/get_maxSchoolYear_CC', { engine: engine })
      await dispatch('schools/get_maxSchoolYear_USL', { engine: engine })

      await dispatch('schools/get_schools', { engine: engine })
      await dispatch('descriptions/get_descriptions', { engine: engine })
      await dispatch('subpage/selected/get_kpis_filter', {
        engine: engine
      })
    } finally {
      // This session is opened fresh on every SSR request (nuxtServerInit
      // runs per-request) using the privileged service-account credentials.
      // Without closing it here, each request leaks an open engine session.
      try {
        await session.close()
      } catch (closeErr) {
        logger.error('Error closing QIX engine session:', closeErr)
      }
    }
  }
}
